/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const calloutButtonDirective = require('./calloutButtonDirective');

const calloutButtonModule = angular
    .module('enervee_utils.callout_button', [
        commonModule.name,
    ])
    .directive('calloutButton', calloutButtonDirective);

module.exports = calloutButtonModule;